import { authorizeGetRequest, authorizePutRequest, getRequest } from "api";
import { IApiResponse, IPaginatedResponse } from "models";
import { ISos, ISosPublicDetailResponse } from "models/sos";

export const sosPublicDetailApi = async (id: string) => {
  return getRequest<ISosPublicDetailResponse>(`sos/${id}/detail`);
};

export const sosDetailApi = async (id: string) => {
  return authorizeGetRequest<IApiResponse<ISosPublicDetailResponse>>(
    `sos/${id}`
  );
};

export const fetchSosApi = async (page: number, perPage: number) => {
  return authorizeGetRequest<IPaginatedResponse<ISos>>(
    `sos?page=${page}&per_page=${perPage}`
  );
};

export const fetchActiveSosApi = async () => {
  return authorizeGetRequest<{ data: number }>(`sos/actives`);
};

export const updateSosSeenApi = async (id: string) => {
  return authorizePutRequest<ISos>(`sos/${id}/seen`, {});
};

export const updateSosStatusApi = async (id: string) => {
  return authorizePutRequest<ISos>(`sos/${id}/deactivated`, {});
};
